export default "__VITE_ASSET__DH26kO1m__"